import './BulkManifestUpdate.css';
import { Button, ButtonGroup, Col, Container, Row } from 'reactstrap';
import InstancesList from './InstancesList';
import { useState, useEffect, shallowEqual } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../context';
import hasPermission from '../../Shared/hasPermission';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import AddFilterModal from './AddFilterModal';
import { Facebook } from 'react-spinners-css';
import EditFilterModal from './EditFilterModal';

const BulkManifestUpdate = () => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [selectedInstanceIds, setSelectedInstanceIds] = useState([]);
    const [allInstances, setAllInstances] = useState([]);

    const [filters, setFilters] = useState([]);

    const [isAddFilterModalOpen, setIsAddFilterModalOpen] = useState(false);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = useState(false);
    const [filterToEdit, setFilterToEdit] = useState({
        filterType: '',
        filterData: '',
        index: -1,
    });

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canAccessBulkUpdater = hasPermission(
        ['BulkManifestUpdate'],
        permissions
    );

    useEffect(() => {
        if (canAccessBulkUpdater) {
            setLoading(true);
            dispatch(actions.instances.getInstances())
                .then((res) => {
                    const instanceList = res?.data || [];
                    setAllInstances(instanceList);
                })
                .then(() => setLoading(false));
        }
    }, [dispatch, canAccessBulkUpdater]);

    const handleSelectSingleInstanceClick = (id) => {
        selectedInstanceIds.includes(id)
            ? setSelectedInstanceIds(
                  selectedInstanceIds.filter((el) => el !== id)
              )
            : setSelectedInstanceIds([...selectedInstanceIds, id]);
    };

    const addFilterBehavior = (filter) => {
        setFilters([...filters, filter]);
    };

    const editFilterBehavior = (filter) => {
        setFilters(
            filters.map((el, index) => {
                if (index === filter.index) {
                    return filter;
                }
                return el;
            })
        );
    };

    const removeFilter = (filterIndex) => {
        setFilters(filters.filter((el, index) => index !== filterIndex));
    };

    const editFilterClickHandler = (filter, index) => {
        setFilterToEdit({ ...filter, index: index });
        setIsEditFilterModalOpen(true);
    };

    if (canAccessBulkUpdater) {
        //apply filters
        let filteredInstances = allInstances;
        filters.forEach((filter) => {
            switch (filter.filterType) {
                case 'instance':
                    filteredInstances = filteredInstances.filter(
                        (instance) =>
                            filter.filterData.includes(
                                instance.id.toLowerCase()
                            ) || filter.filterData.length === 0
                    );
                    break;
                case 'pims':
                    filteredInstances = filteredInstances.filter(
                        (instance) =>
                            filter.filterData.includes(
                                instance.practice?.pimsInfo?.displayName
                            ) || filter.filterData.length === 0
                    );
                    break;
            }
        });

        return (
            <div className="content-wrapper">
                <AddFilterModal
                    isOpen={isAddFilterModalOpen}
                    closeBehavior={() => setIsAddFilterModalOpen(false)}
                    addFilterBehavior={addFilterBehavior}
                />
                <EditFilterModal
                    isOpen={isEditFilterModalOpen}
                    closeBehavior={() => setIsEditFilterModalOpen(false)}
                    editFilterBehavior={editFilterBehavior}
                    filterToEdit={filterToEdit}
                />
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Bulk Manifest Update</h1>
                            </div>
                        </div>
                    </div>
                </section>
                {loading ? (
                    <h2 className="m-4 text-center">
                        <Facebook color="#eee" />
                    </h2>
                ) : (
                    <Container id="dashboard" className="my-4 ov-dashboard">
                        <Container>
                            <Row>
                                <Col>
                                    <ButtonGroup
                                        style={{ margin: '6px 4px 6px 0px' }}>
                                        <Button
                                            onClick={() =>
                                                setIsAddFilterModalOpen(true)
                                            }>
                                            <FontAwesomeIcon icon={faPlus} />{' '}
                                            Add Filter
                                        </Button>
                                    </ButtonGroup>
                                    {filters.map((filter, index) => {
                                        return (
                                            <ButtonGroup
                                                style={{ margin: '4px 6px' }}>
                                                <Button
                                                    onClick={() =>
                                                        editFilterClickHandler(
                                                            filter,
                                                            index
                                                        )
                                                    }>
                                                    {filter.filterType}
                                                </Button>
                                                <Button
                                                    onClick={() =>
                                                        removeFilter(index)
                                                    }>
                                                    <FontAwesomeIcon
                                                        icon={faTrash}
                                                    />
                                                </Button>
                                            </ButtonGroup>
                                        );
                                    })}
                                </Col>
                            </Row>
                            <Row>
                                <i>
                                    *Note: multiple filters act as AND filters
                                </i>
                            </Row>
                        </Container>
                        <InstancesList
                            instances={filteredInstances}
                            selectedInstanceIds={selectedInstanceIds}
                            handleSelectSingleInstanceClick={
                                handleSelectSingleInstanceClick
                            }
                        />
                        <div>
                            <Button
                                color="primary"
                                onClick={() =>
                                    setSelectedInstanceIds(
                                        filteredInstances.map((el) => el.id)
                                    )
                                }>
                                Select All
                            </Button>{' '}
                            {selectedInstanceIds.length > 0 && (
                                <Button
                                    color="secondary"
                                    onClick={() => setSelectedInstanceIds([])}>
                                    {`Clear All (${selectedInstanceIds.length})`}
                                </Button>
                            )}
                        </div>
                    </Container>
                )}
            </div>
        );
    }

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Unauthorized</h1>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BulkManifestUpdate;
